import { InformationCircleIcon } from "@heroicons/react/outline";
import classnames from "classnames";
import { Field } from "formik";

interface Props {
  name: string;
  /**
   * If not provided, the label will be the same as the name
   */
  label?: string;
  type?: "text" | "number" | "textarea" | "email" | "password";
  disabled?: boolean;
  placeholder?: string;
  autocomplete?: {
    field: string;
    type?: "slug";
  };
  icon?: JSX.Element;
  toggleable?: boolean;
  helperText?: string | null;
}

const InputToggle: React.FC<Props> = ({
  name = "",
  toggleable = true,
  disabled = false,
  label,
  helperText,
}) => {
  const sliderClassName = classnames({
    "slider round": true,
    "cursor-pointer": toggleable,
    "cursor-default": !toggleable,
  });

  return (
    <div className="w-full grid grid-cols-[1fr_44px] ">
      <label
        htmlFor={name}
        className="text-input leading-5 cursor-pointer text-black mb-1 w-full mr-auto peer-focus:underline"
      >
        {label}
      </label>
      <label htmlFor={name} className="switch">
        <Field
          disabled={disabled}
          name={name}
          id={name}
          type="checkbox"
          className="peer"
        />
        <span className={sliderClassName} />
      </label>
      {helperText && (
        <div className="text-sm flex gap-2 items-center">
          <div>
            <InformationCircleIcon className="h-4 w-4 text" />
          </div>
          <p>{helperText}</p>
        </div>
      )}
    </div>
  );
};
export default InputToggle;
